//提货单

import UltMeta, { Meta } from "./UltMeta/index";

class GoodsState extends UltMeta {
    FINISHED = new Meta(3, "已完成");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const GOODS_STATE = new GoodsState();

/**
 *
 */
class QueryType extends UltMeta {
    ONE = new Meta(1, "作为提货单位");
    TWO = new Meta(2, "作为供货单位");
}

export const QUERY_TYPE = new QueryType();

class Type extends UltMeta {
    ONE = new Meta(1, "直采-供应商", "01");
    TWO = new Meta(2, "联合采购-联合采购商", "02");
    THREE = new Meta(3, "联合采购-供应商", "03");
}

export const TYPE = new Type();

/**
 * 运输类型
 */
class TransportType extends UltMeta {
    SHIPPING = new Meta(1, "船运");
    AUTOMOBILE_TRANSPORT = new Meta(2, "汽运");
}

export const TRANSPORT_TYPE = new TransportType();

/**
 * 签收状态
 */
class ReceiptState extends UltMeta {
    UNSIGNED = new Meta(1, "未签收");
    SIGNING = new Meta(2, "签收中");
    FINISHED = new Meta(3, "已签收");
}

export const RECEIPT_STATE = new ReceiptState();
